
import { Vue, Options } from 'vue-class-component'
import { Pagination, Autoplay } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/vue/swiper-vue'
import 'swiper/swiper-bundle.css'
import liff from '@line/liff'
import { useStore } from '@/store'
import { BannersItemList, MarketingBanner } from '@/interfaces/banners-list'
import QSkeleton from 'quasar/src/components/skeleton/QSkeleton.js';
import { Watch } from 'vue-property-decorator'

@Options({
  components: {
    Swiper,
    SwiperSlide,
    QSkeleton
  },
  computed: {
    isLoading() {
      return this.store.state.bannersList.banners.isLoading
    },
    bannersList() {
      return this.$store.state.bannersList.banners.items
    }
  }
})
export default class BannersList extends Vue {
  store = useStore()
  imagesToPreload: string[] = []
  modules: any = [Pagination, Autoplay]
  stateAutoplay = false
  optionSwiper = {
    pagination: { clickable: true },
    autoplay: { delay: 2500, disableOnInteraction: false },
  }

  hasBeenBlured = false
  blurCounting = 0
  bannersListAfterHandle: BannersItemList[] = []
  isUpdated = false // the banners should be updated only one time

  @Watch('store.state.bannersList.banners.items', { immediate: true, deep: true })
  onBannersListChange(newVal: BannersItemList[]) {
    if (newVal.length > 0 && !this.isUpdated) {
      this.handleBannerImage(newVal)
    }
  }

  handleBannerClickEvent() {
    window.onblur = () => {
      this.hasBeenBlured = true
      this.blurCounting++
    }
    window.onfocus = () => {
      if (this.hasBeenBlured) {
        this.closeLoadingLabel()
        this.hasBeenBlured = false
      }
    }
  }
  
  

  handleBannerImage(banners: BannersItemList[]) {
    console.log('proceed banners ', banners)
    this.isUpdated = true
    if (!Array.isArray(banners)) return

    banners.forEach((banner) => {
      if (Array.isArray(banner?.marketingBannerFragment)) {
        banner.marketingBannerFragment = banner.marketingBannerFragment.filter(
          (detail) => !!detail?.bannerImage?._publishUrl
        )
      }
    })

    this.bannersListAfterHandle = banners.filter(
      (banner) =>
        Array.isArray(banner.marketingBannerFragment) &&
        banner.marketingBannerFragment.length > 0
    )

    this.setStateImgLoaded(this.bannersListAfterHandle)
    this.handleBannerClickEvent()

    return this.bannersListAfterHandle
  }

  setDuration(time: number) {
    this.optionSwiper.autoplay.delay = time > 0 ? time * 1000 : 2500
    return this.optionSwiper.autoplay
  }

  setStateImgLoaded(banners: BannersItemList[]) {
    banners.forEach((banner) => {
      banner?.marketingBannerFragment?.forEach((bannerImage) => {
        const bannerImg = bannerImage?.bannerImage
        const publishUrl = bannerImg?._publishUrl

        if (publishUrl) {
          this.imagesToPreload.push(publishUrl)
        }
      })
    })

    const imagePromises = this.imagesToPreload.map((imageSrc) => {
      return new Promise<void>((resolve, reject) => {
        const img = new Image()
        img.src = imageSrc
        img.onload = () => resolve()
        img.onerror = () => reject(new Error(`Failed to load image: ${imageSrc}`))
      })
    })

    Promise.all(imagePromises)
      .then(() => {
        this.stateAutoplay = true
      })
      .catch((error) => {
        console.error('Some image(s) failed to load!')
        console.error(error.message)
        this.stateAutoplay = true
      })
  }

  openOneApp(url: string) {
    window.open(url, '_blank')
  }

  openAppStore() {
    liff.openWindow({
      url: process.env.VUE_APP_DOWNLOAD_LOTUSS || '',
    })
  }

  openUrl(banner: MarketingBanner) {
    const bannerUrl = banner.externalBannerLink || banner.deepLinkForApp || banner.shareLink
    if (bannerUrl) {
      if (banner.deepLinkForApp) {
        this.showLoadingLabel()
        const previousBlur = this.blurCounting
        this.openOneApp(bannerUrl)
        setTimeout(() => {
          /*
          the app on blur state is not updated,
          we will assume the app does not open one app
          so that we will force use to open app store instead
          */
          if (previousBlur === this.blurCounting) {
            this.openAppStore()
            this.closeLoadingLabel()
          }
        }, 2000)
      } else {
        this.openOneApp(bannerUrl)
      }
    }
  }

  showLoadingLabel() {
    this.store.commit('app/setIsLoadingHome', true)
    this.store.commit('app/setLoadingBarLabelHtml', 'กำลังเปิด<br/>โลตัส สมาร์ท แอพ')
  }

  closeLoadingLabel() {
    this.store.commit('app/setIsLoadingHome', false)
    this.store.commit('app/setLoadingBarLabelHtml', '')
  }
}
